import { FaInstagram } from "react-icons/fa6"; // Using Instagram icon as placeholder
import { type SocialPlatformBaseSettings } from "./types";

export const threadsBaseSettings: SocialPlatformBaseSettings = {
  name: "Threads",
  icon: FaInstagram, // Needs specific icon if available
  fields: {
    caption: "optional",
    altText: "optional",
    linkAttachment: "optional",
    userTags: "optional",
  },
  limits: {
    caption: 500,
    images: 10,
    videos: 1,
    videoDurationSeconds: 5 * 60, // 5 minutes
  },
  postTypes: {
    post: {},
  },
};
